// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"z1-z","dimensionLabel":"A1-z","styleChooserControlWrapper":"B1-z","styleChooserControl":"C1-z","disabled":"D1-z","giftCard":"E1-z","styleChooserText":"F1-z"};